<div class="modal-overlay"></div>
<app-breadcrumbs></app-breadcrumbs>
<div class="sidebar-style-9">
  <div class="section">
    <div class="container">
      <app-image-cropper
      #imageCopperElement
      [isAllowedImage]="isAllowedImage"
      [imageChangedEvent]="imageChangedEvent"
      [imageURL]="imageURL"
      [maintainAspectRatio]="maintainAspectRatio"
      [containWithinAspectRatio]="containWithinAspectRatio"
      [aspectRatio]="aspectRatio"
      [resizeToWidth]="resizeToWidth"
      [cropperMinWidth]="cropperMinWidth"
      [onlyScaleDown]="onlyScaleDown"
      [roundCropper]="roundCropper"
      [cropper]="cropper"
      [canvasRotation]="canvasRotation"
      [transform]="transform"
      [alignImage]="alignImage"
      (cropImageEvent)="onCropImage($event)"
    ></app-image-cropper>
      <form [formGroup]="addProductForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-lg-8">
            <div class="sigma_form style-7">
              <div class="form-block">
                <h4>{{isAddDrug ? 'Drug Information' : 'Test Information'}}</h4>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>Name</label>
                      <i class="fal fa-briefcase-medical"></i>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="{{isAddDrug ? 'Panadol' : 'Blood Typing'}}"
                        formControlName="name"
                      >
                      <div *ngIf="submitted && f.name.errors" class="is-invalid">
                        <div *ngIf="f.name.errors.required">
                          {{ isAddDrug ? 'Drug Name required' : 'Test Name required' }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!isAddDrug" class="col-lg-6">
                    <div class="form-group">
                      <label>Selling Cost</label>
                      <i class="fal fa-money-bill"></i>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="30000"
                        formControlName="price"
                      >
                      <div *ngIf="submitted && f.price.errors" class="is-invalid">
                        <div *ngIf="f.price.errors.required">Selling Cost required</div>
                        <div *ngIf="f.price.errors.pattern">Please enter a valid number</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isSuperAdmin && !isAddDrug" class="col-lg-6">
                    <div class="form-group">
                      <label>Partner Cost</label>
                      <i class="fal fa-money-bill"></i>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="20000"
                        formControlName="partnerPrice"
                      >
                      <div *ngIf="submitted && f.partnerPrice.errors" class="is-invalid">
                        <div *ngIf="f.partnerPrice.errors.required">Partner Cost required</div>
                        <div *ngIf="f.partnerPrice.errors.pattern">Please enter a valid number</div>

                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label>Category</label>
                      <select class="form-control" placeholder="Category" formControlName="category"
                      >
                        <option value="" disabled selected>Category</option>
                        <option  *ngFor="let item of (isAddDrug ? pharmacyCategories : categories)" [value]="item.title">{{ item.title }}</option>
                      </select>
                      <div *ngIf="submitted && f.category?.errors?.required" class="is-invalid">
                        Category required
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!isAddDrug" class="col-lg-6">
                    <div class="form-group">
                      <label>Duration</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="2"
                          formControlName="time"
                        >
                        <select class="form-control" placeholder="Hours" formControlName="duration">
                        <option value="" disabled selected>Time</option>
                          <option value="Minutes">Minutes</option>
                          <option value="Hours">Hours</option>
                          <option value="Days">Days</option>
                        </select>
                      </div>
                      <div *ngIf="submitted && (f.time.errors || f.duration.errors)" class="is-invalid">
                        <div *ngIf="f.time.errors?.required || f.duration.errors?.required">Time and Duration required</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isAddDrug" class="col-lg-6">
                    <div class="form-group">
                      <label>Country Of Origin</label>
                      <!-- <i class="fal fa-globe"></i> -->
                      <select class="form-control" placeholder="Uganda" formControlName="country_of_origin">
                        <option value="">Select country</option>
                        <option  *ngFor="let country of countryNames" [value]="country">
                          {{ country }}
                        </option>
                      </select>
                      <div *ngIf="submitted && f.country_of_origin.errors" class="is-invalid">
                        <div *ngIf="f.country_of_origin.errors.required">country of origin required</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isAddDrug" class="col-lg-6">
                    <div class="form-group">
                      <label>Composition</label>
                      <i class="fal fa-flask"></i>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="200mg sulphur"
                        formControlName="composition"
                      >
                      <div *ngIf="submitted && f.composition.errors" class="is-invalid">
                        <div *ngIf="f.composition.errors.required">Composition required</div>
                      </div>
                    </div>
                  </div>
                  <!--TODO: temporarily removed until client decides -->
                  <!-- <div *ngIf="isAddDrug" class="col-lg-6">
                    <div class="form-group">
                      <label>Expiry Date</label>
                      <i class="fal fa-calendar-alt"></i>
                      <input 
                        type="date"  
                        class="form-control"
                        formControlName="expiry_date"
                      >
                      <div *ngIf="submitted && f.expiry_date.errors" class="is-invalid">
                        <div *ngIf="f.expiry_date.errors.required">Expiry Date required</div>
                      </div>
                    </div>
                  </div> -->
                  <div *ngIf="isAddDrug" class="col-lg-12">
                    <div formArrayName="quantityTypes" class="form-group">
                      <label>Drug Quantity Types & Prices</label>
                      <div *ngFor="let qty of quantityTypes.controls; let i = index" [formGroupName]="i" class="row align-items-center mb-3">
                        <div class="col-md-4">
                          <p>Type</p>
                          <select class="form-control" formControlName="name">
                            <option value="" disabled selected>Select quantity type</option>
                            <option *ngFor="let option of quantityTypeOptions" [value]="option.name">
                              {{ option.name | titlecase }}</option>
                          </select>
                          <input
                            *ngIf="qty.get('name')?.value === 'other'"
                            type="text"
                            class="form-control mt-2"
                            formControlName="customType"
                            placeholder="Enter quantity type"
                          />
                        </div>
                        <div class="col-md-3">
                          <p>Partner price</p>
                          <input
                            type="text"
                            class="form-control"
                            formControlName="partner_price"
                            placeholder="Partner Price"
                          />
                        </div>
                        <div class="col-md-3">
                          <p>selling price</p>
                          <input
                            type="text"
                            class="form-control"
                            formControlName="selling_price"
                            placeholder="Selling Price"
                          />
                        </div>
                        <div class="col-md-2">
                          <p>Availability</p>
                          <select class="form-control" placeholder="stock" formControlName="is_in_stock"
                          >
                            <option value="yes">Yes</option>
                            <option value="no">no</option>
                          </select>
                        </div>
                        <div class="col-md-2 mt-1">
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            (click)="removeQuantityType(i)"
                            [disabled]="quantityTypes.length <= 1"
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                      <button type="button" class="btn btn-secondary mt-2" (click)="addQuantityType()">+ Add Quantity Type</button>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label>Upload Medical Test Images</label>
                      <div class="upload-photo">
                        <div class="d-table">
                          <div class="d-table-cell">
                            <div class="form-group">
                              <i *ngIf="!croppedImages.length" class="icofont-photobucket"></i>
                              <input
                                *ngIf="croppedImages.length < 5"
                                class="form-control-file"
                                type="file"
                                accept="image/png, image/jpeg, image/jpg"
                                (change)="onImageChange($event)"
                              >
                            </div>
                            <div *ngFor="let croppedImage of croppedImages; let i = index" class="image-container mb-2">
                              <img
                                [src]="croppedImage"
                                alt="Preview"
                                class="img-thumbnail mr-2"
                                style="max-height: 100px;"
                              />
                              <button
                                type="button"
                                class="btn btn-sm btn-danger delete"
                                (click)="onRemoveImge(i, false)"
                              >Remove</button>
                            </div>
                            <ng-container *ngIf="editProduct && editProduct.images && editProduct.images.length > 0;">
                              <div *ngFor="let image of editProduct.images; let i = index" class="image-container mb-2">
                                <img [src]="image" alt="Product Image" class="img-thumbnail mr-2" style="max-height: 100px;">
                                <button
                                  type="button"
                                  class="btn btn-sm btn-danger delete"
                                  (click)="onRemoveImge(i, true)"
                                >Remove</button>
                              </div>
                            </ng-container>
                            <div *ngIf="submitted && (!croppedImages.length && (!editProduct || !editProduct.images || editProduct.images.length === 0))"
                                class="is-invalid">
                              At least one photo is required
                            </div>
                            <div *ngIf="croppedImages.length === 5" class="mt-3">
                              <p class="text-danger">You have reached the maximum limit of 5 images.</p>
                            </div>
                            <div *ngIf="!isAllowedImage" class="is-invalid">
                              Width & height max 600px X 400px and not greater than 5 MB
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label>Description</label>
                      <i class="fal fa-comment-medical"></i>
                      <app-rich-text-editor 
                        [invalidInput]="submitted && f.description.invalid"
                        [formGroup]="addProductForm"
                        formControlName="description"
                      >
                      </app-rich-text-editor>
                      <div *ngIf="submitted && f.description.errors" class="is-invalid">
                        <div *ngIf="f.description.errors.required">Description required</div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    [disabled]="addProductForm.invalid "
                    class="sigma_btn btn-sm mt-4">
                    Submit
                    <i class="fal fa-arrow-right ml-3"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="sidebar style-10 mt-5 mt-lg-0">
              <!-- Test Widget -->
              <div class="widget widget-booking">
                <h5 class="widget-title">
                  {{isAddDrug ? 'Drug Summary' : 'Test Summary'}}
                </h5>
                <ul>
                  <li class="d-flex align-items-center justify-content-between">
                    <span>{{ isAddDrug ? 'Drug Name' : 'Test Name' }}</span>
                    <span>{{f.name.value}}</span>
                  </li>
                  <li *ngIf="!isAddDrug" class="d-flex align-items-center justify-content-between">
                    <span>Selling Price</span>
                    <span>{{f.price.value}}</span>
                  </li>
                  <li *ngIf="isSuperAdmin && !isAddDrug" class="d-flex align-items-center justify-content-between">
                    <span>Partner Price</span>
                    <span>{{f.partnerPrice.value}}</span>
                  </li>
                  <li class="d-flex align-items-center justify-content-between">
                    <span>Category</span>
                    <span>{{f.category.value}}</span>
                  </li>
                  <li *ngIf="!isAddDrug" class="d-flex align-items-center justify-content-between">
                    <span>Duration</span>
                    <span>{{f.time.value + ' ' + f.duration.value}}</span>
                  </li>
                  <li *ngIf="isAddDrug" class="d-flex align-items-center justify-content-between">
                    <span>Origin</span>
                    <span>{{f.country_of_origin.value}}</span>
                  </li>
                  <li *ngIf="isAddDrug" class="d-flex align-items-center justify-content-between">
                    <span>Composition</span>
                    <span>{{f.composition.value}}</span>
                  </li>
                  <!-- TODO: temporarily removed until client decides -->
                  <!-- <li *ngIf="isAddDrug" class="d-flex align-items-center justify-content-between">
                    <span>Expiry Date</span>
                    <span>{{ f.expiry_date.value | date: 'mediumDate' }}</span>
                  </li> -->
                  <ng-container *ngIf="isAddDrug">
                    <h5 class="center mt-2 mb-1">Quantity Details</h5>
                    <ul *ngFor="let quantity of quantityTypes.controls">
                      <li class="d-flex align-items-center justify-content-between">
                        <span>Type</span>
                        <span>{{ quantity.get('customType')?.value || quantity.get('name')?.value }}</span>
                      </li>
                      <li class="d-flex align-items-center justify-content-between">
                        <span>Partner Price</span>
                        <span>{{ quantity.get('partner_price')?.value }}</span>
                      </li>
                      <li class="d-flex align-items-center justify-content-between">
                        <span>Selling Price</span>
                        <span>{{ quantity.get('selling_price')?.value }}</span>
                      </li>  
                      <li class="d-flex align-items-center justify-content-between">
                        <span>Available</span>
                        <span>{{ quantity.get('is_in_stock')?.value }}</span>
                      </li>
                      <hr>
                    </ul>
                  </ng-container>
                </ul>
                <ul>
                  <!-- TODO: reuse if Client requests -->
                  <!-- <li class="d-flex align-items-center justify-content-between">
                    <button
                      type="submit"
                      [disabled]="addProductForm.invalid "
                      class="sigma_btn btn-block btn-sm mt-4">
                      Submit
                      <i class="fal fa-arrow-right ml-3"></i>
                    </button>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
